const readBool = (value: string | undefined): boolean =>
  value === 'true' || value === '1'

export const NEW_PRICING_ENABLED = readBool(import.meta.env.VITE_NEW_PRICING_ENABLED)

export const USE_APP_SIGNUP = readBool(import.meta.env.VITE_USE_APP_SIGNUP)

export const APP_BASE_URL =
  (import.meta.env.VITE_APP_BASE_URL as string | undefined) ?? 'https://app.wealthspace.co.uk'
